import { AbstractControl, ValidatorFn } from '@angular/forms';

export function surveyCloseAtValidator(offset: number = 0): ValidatorFn {
  return (control: AbstractControl): { [key: string]: { past: number } } => {
    const servertimestamp = Date.now() + offset;
    if (typeof control.value === 'number' && control.value < servertimestamp) {
      return {
        close_at: { past: servertimestamp - control.value }
      };
    }
    return null;
  };
}
